import { client, errorValidation } from "./service";

export const getProperty = async function (id) {
  try {
    let response = await client.get(`/listing/detail/${id}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data, error: null };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return { data: null, ...errorValidation(e) }
  }
}

export const getListing = async function ({
  queryName,
  sort,
  type,
  listingType,
  listingStatus,
  facePosition,
  priceMin,
  priceMax,
  floor,
  bedRoom,
  ukuranBangunanP,
  ukuranBangunanL,
  luasTanah,
  limit
}) {
  try {
      let response = await client.get(`/listing/list?queryName=${queryName || ''}&sort=${sort 
        || ''}&type=${type || ''}&listingType=${listingType || ''}&facePosition=${facePosition 
          || ''}&priceMin=${priceMin || ''}&priceMax=${priceMax || ''}&floor=${floor || ''}&bedRoom=${bedRoom 
            || ''}&ukuranBangunanP=${ukuranBangunanP || ''}&ukuranBangunanL=${ukuranBangunanL 
              || ''}&listingStatus=${listingStatus || ''}&luasTanah=${luasTanah || ''}&limit=${limit || ''}`);
      if (response.data.statusCode !== 200) { throw response.data.data; }
      let data = response.data.data;
      return { data, error: null };
    } catch (e) {
      // return { error: e.response.data.errorCode }
      return { data: null, ...errorValidation(e) }
    }
}

export const shareListing = async function ({
  listingId, url, uniqueId
}) {
  try {
    let response = await client.post(`/listing/share`, {
      listingId, url, uniqueId
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data, error: null };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return { data: null, ...errorValidation(e) }
  }
}